// src/firebase/cloudinaryService.js

const CLOUD_NAME = "dhiahjrkm";
const UPLOAD_PRESET = "website_uploads";

export const uploadToCloudinary = async (file) => {
    try {
        const formData = new FormData();

        formData.append("file", file);
        formData.append("upload_preset", UPLOAD_PRESET);

        const response = await fetch(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`,
            {
                method: "POST",
                body: formData,
            }
        );

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error?.message || "Upload failed");
        }

        return {
            url: data.secure_url,
            publicId: data.public_id,
            width: data.width,
            height: data.height,
        };
    } catch (error) {
        console.error("Cloudinary Upload Error:", error);
        throw error;
    }
};